import axios from "../axios";
import { Cookies } from "react-cookie";
const endPoint = `/crm/login/`;

const cookie = new Cookies();

export const loginapi = async (userName, password) => {
  const res = await axios.post(`${endPoint}`, { userName: userName, password });
  if (res.data.token) {
    await cookie.set("crm", "Bearer " + res.data.token, { path: "/" });
    await cookie.set("role", res.data.role, { path: "/" });
    await cookie.set("id", res.data.info._id.toString(), { path: "/" });
    await cookie.set("super", res.data.super.toString(), { path: "/" });
    return {
      success: true,
      freelancer: res.data.freelancer,
      info: res.data.info,
      message: res.data.message,
    };
  } else return { success: false, message: res.data.message };
};

export const getInfoData = async (userName, password) => {
  const token = cookie.get("crm");
  if (token) {
    const res = await axios.get(`${endPoint}data`, {
      headers: { Authorization: token },
    });
    await cookie.set("role", res.data.info.role, { path: "/" });
    await cookie.set("id", res.data.info.id, { path: "/" });
    await cookie.set("super", res.data.info.super.toString(), { path: "/" });
    return {
      success: true,
      info: res.data.info,
      message: res.data.message,
    };
  } else return { success: false, message: "error" };
};
